import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotSubscribedIcon from '@material-ui/icons/NotificationsOffOutlined';
import SubscribedIcon from '@material-ui/icons/NotificationsActiveOutlined';
import IconButton from '@material-ui/core/IconButton';
import SpacingStyles from '../../../styles/helpers/spacing';

export class CommentSubscribedButton extends PureComponent {
  static propTypes = {
    subscribed: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { classes } = this.props;
    const { subscribed, onClick } = this.props;

    return (
      <IconButton
        color="primary"
        onClick={onClick}
        classes={{ root: classes.noPadding }}
      >
        {subscribed ? <SubscribedIcon /> : <NotSubscribedIcon />}
      </IconButton>
    );
  }
}
export default withStyles(SpacingStyles)(CommentSubscribedButton);
